<app-callcard-info-card [callcard]="callcard"></app-callcard-info-card>
<app-callcard-cevents-card [callcard]="callcard"></app-callcard-cevents-card>
<app-callcard-clocations-card [callcard]="callcard"></app-callcard-clocations-card>
<app-callcard-cnotes-card [callcard]="callcard"></app-callcard-cnotes-card>
